"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** A modal component that displays another component inside a modal. */
var Modal = function Modal(_ref) {
  var className = _ref.className,
    color = _ref.color,
    size = _ref.size,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    children = _ref.children,
    title = _ref.title,
    visible = _ref.visible;
  var modalRef = (0, _react.useRef)(null);
  var handleClickOutside = function handleClickOutside(e) {
    var target = e.target;
    if (visible && modalRef.current && !modalRef.current.contains(target)) {
      onClose();
    }
  };
  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  var classNameShield = "".concat(className, " shield");
  if (visible) classNameShield += ' visible';
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    className: classNameShield,
    color: color,
    size: size
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " modal"),
    ref: modalRef
  }, title ? /*#__PURE__*/_react["default"].createElement("h2", {
    className: className
  }, title) : null, children));
};
exports.Modal = Modal;